package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaLink
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.widgets.StoreUserInviteStatusBadge
import gr.tech.GRAttestation.models.storeusers.STORE_USER_INVITE_STATUS
import gr.tech.GRAttestation.sections.admin.AdminTableContainer
import gr.tech.GRAttestation.styles.admin.AdminTableStickyColumn
import gr.tech.GRAttestation.styles.grstyles.DropdownLinkStyle
import gr.tech.GRAttestation.util.ROUTES
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import gr.tech.models.storeusers.StoreUsersInviteDTO
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun AdminStoreInvitesTable(
    invites: List<StoreUsersInviteDTO>,
    onCancel: (StoreUsersInviteDTO) -> Unit,
) {
    val scope = rememberCoroutineScope()

    AdminTableContainer {
        Table(
            attrs = Modifier
                .classNames("table")
                .minWidth(700.px)
                .height(100.percent)
                .fillMaxWidth()
                .toAttrs()
        ) {
            Thead(
                attrs = Modifier
                    .styleModifier { property("table-layout", "fixed") }
                    .toAttrs()
            ) {
                Tr {
                    listOf(
                        "Email",
                        "Store",
                        "Notes",
                        "Status",
                        "Sent",
                    ).forEach { header ->
                        Th(attrs = Modifier.minWidth(100.px).classNames("col").toAttrs()) {
                            Text(header)
                        }
                    }
                    Th(
                        attrs = Modifier
                            .then(AdminTableStickyColumn.toModifier())
                            .width(120.px)
                            .toAttrs()
                    ) {
                        Text("Action")
                    }
                }
            }
            Tbody {
                if (invites.isNotEmpty()) {
                    invites.forEach { invite ->
                        AdminStoreInviteTableRow(
                            invite = invite,
                            onCancel = { onCancel(it) },
                            scope = scope,
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun AdminStoreInviteTableRow(
    invite: StoreUsersInviteDTO,
    onCancel: (StoreUsersInviteDTO) -> Unit,
    scope: CoroutineScope,
) {
    var copiedClicked by remember { mutableStateOf(false) }

    Tr {
        Td { Text(invite.email ?: "-") }
        Td { Text(invite.storeName ?: "-") }
        Td { Text(invite.notes ?: "-") }
        Td { StoreUserInviteStatusBadge(invite.status) }
        Td {
            Span { Text(formatDateOnly(invite.createdAt)) }
            TableDateTimeTooltip(invite.createdAt)
        }

        // Action column
        Td(
            attrs = Modifier
                .width(150.px)
                .padding(.5.cssRem)
                .then(AdminTableStickyColumn.toModifier())
                .toAttrs()
        ) {
            if (invite.status == STORE_USER_INVITE_STATUS.PENDING.bit) {
                Div(
                    attrs = Modifier
                        .classNames("btn-group")
                        .toAttrs()
                ) {
                    Div(
                        attrs = Modifier
                            .classNames("btn-group", "dropstart")
                            .toAttrs()
                    ) {
                        Button(
                            attrs = Modifier
                                .classNames("btn", "btn-outline-secondary")
                                .toAttrs{
                                    attr("data-bs-toggle", "dropdown")
                                }
                        ) {
                            FaEllipsisVertical()
                        }
                        Ul(
                            attrs = Modifier.classNames("dropdown-menu")
                                .toAttrs()
                        ) {
                            Li {
                                Span(
                                    attrs = DropdownLinkStyle.toModifier().classNames("dropdown-item", "text-danger")
                                        .onClick { it.preventDefault(); onCancel(invite) }
                                        .toAttrs()
                                ) { Text("Cancel") }
                            }
                        }
                    }
                    Button(
                        attrs = Modifier.classNames("btn", "btn-outline-secondary")
                            .width(80.px)
                            .onClick {
                                it.preventDefault()
                                val link = "${ROUTES.FRONTEND_URL}/finish-registration?token=${invite.token}"
                                js("navigator.clipboard.writeText(link)")

                                scope.launch {
                                    copiedClicked = true
                                    delay(750)
                                    copiedClicked = false
                                }
                            }
                            .toAttrs(),
                    ) {
                        if (copiedClicked) {
                            FaCheck()
                        } else {
                            Text("Link")
                            FaLink(Modifier.margin(left = 4.px))
                        }
                    }
                }
            }
        }
    }
}
